import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { Environment } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { getToolIcon } from '../../../../helpers/utils';
import { EnvironmentService } from '../../../shared/services/environment.service';
import { DeleteEnvironmentDialogComponent } from './delete-environment-dialog/delete-environment-dialog.component';
import { EditEnvironmentDialogComponent } from './edit-environment-dialog/edit-environment-dialog.component';
import { NewEnvironmentDialogComponent } from './new-environment-dialog/new-environment-dialog.component';

@Component({ standalone: false, 
  templateUrl: './environment.component.html',
  styleUrls: ['./environment.component.scss'],
})
export class EnvironmentComponent implements OnInit {
  public environments$: Observable<Environment[]>;
  public getToolIcon = getToolIcon;

  constructor(
    public dialogService: DialogService,
    public environmentService: EnvironmentService,
    public snackBarService: MatSnackBar,
  ) {}

  public ngOnInit(): void {
    this.environments$ = this.environmentService.getAllEnvironments();
  }

  public editEnvironment(environment: Environment): void {
    const dialogRef: DialogRef = this.dialogService.open(
      EditEnvironmentDialogComponent,
      { data: environment },
    );

    dialogRef.afterClosed().subscribe((updatedHunt: Environment) => {
      if (updatedHunt)
        this.environments$ = this.environmentService.getAllEnvironments();
    });
  }

  public deleteEnvironment(environment: Environment): void {
    const dialogRef: DialogRef = this.dialogService.open(
      DeleteEnvironmentDialogComponent,
      { data: environment },
    );

    dialogRef.afterClosed().subscribe((deletedEnvironment: Environment) => {
      if (deletedEnvironment) {
        this.snackBarService.open(
          'Deleted environment - ' + deletedEnvironment.name,
          null,
          {
            duration: 5 * 1000,
          },
        );
        this.environments$ = this.environmentService.getAllEnvironments();
      }
    });
  }

  public newEnvironment(): void {
    const dialogRef: DialogRef = this.dialogService.open(
      NewEnvironmentDialogComponent,
    );

    dialogRef.afterClosed().subscribe((updatedHunt: Environment) => {
      if (updatedHunt)
        this.environments$ = this.environmentService.getAllEnvironments();
    });
  }
}
